import styled from '@emotion/styled';

import { COLORS, COLORS3, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';

import BulletedList from '@zola/zola-ui/src/components/PreAuth/BulletedList';

export const IconListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${SPACING.LG} 0;

  p {
    margin: ${SPACING.XS} 0 0 0;
    text-align: center;

    ${FONT.textSizeUltraCompact(FONT.SIZE.SMALL)}
    color: ${COLORS3.BLACK_100};
    font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Message = styled.li`
  display: flex;
  margin-bottom: ${SPACING.XS};
  color: ${COLORS.BLACK};
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALL)};
  &:before {
    top: 3px !important;
  }
`;

export const StyledBulletedList = styled(BulletedList)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Hed = styled.h5`
  ${FONT.textSizeUltraCompact(FONT.SIZE.REGULAR)}
  color: ${COLORS3.BLACK_100};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  letter-spacing: -0.02em;
  margin: 0 0 ${SPACING.S16} 0;
`;

export const StyledItems = styled.li`
  ${FONT.textSizeUltraCompact(FONT.SIZE.SMALL)}
  align-items: flex-start;
  color: ${COLORS3.BLACK_100};
  display: flex;
  flex-flow: row;
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  margin-bottom: ${SPACING.XS};

  svg {
    display: block;
    margin-right: ${SPACING.SM};
    min-width: 15px;
    min-height: 10px;
    width: 15px;
    height: 10px;
  }
`;
